import styled from 'styled-components';

/*
 * The auth form's own furniture. The card, the column and the split are the
 * layout's — see components/layout/auth — so what is left here is the type.
 */

export const AuthContainer = styled.div`
  width: 100%;
`;

export const FormLogin = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormTitle = styled.h1`
  font-family: var(--font-ui);
  font-size: var(--fs-display);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-body);
  letter-spacing: -0.01em;
  color: var(--text);
`;

export const SubTitle = styled.p`
  margin-top: var(--s1);
  font-family: var(--font-ui);
  font-size: var(--fs-label);
  font-weight: var(--fw-regular);
  line-height: var(--lh-body);
  color: var(--text-muted);
`;

/*
 * The line under the form — "Already have login and password? Sign in".
 * Separated by a rule rather than by a gap, so it reads as a way out of the
 * screen rather than as another part of the form.
 */
export const Foot = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--s1);
  margin-top: var(--s5);
  padding-top: var(--s4);
  border-top: 1px solid var(--line);
  font-family: var(--font-ui);
  font-size: var(--fs-micro);
  font-weight: var(--fw-regular);
  line-height: var(--lh-body);
  color: var(--text-muted);

  a {
    color: var(--primary);
    font-weight: var(--fw-medium);
  }

  a:hover {
    color: var(--primary-hover);
    text-decoration: underline;
  }
`;

export const Div = styled.div``;

/* The row that carries "Remember me" and the way to the reset screen. */
export const Links = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--s3);

  a {
    font-family: var(--font-ui);
    font-size: var(--fs-label);
    font-weight: var(--fw-medium);
    line-height: var(--lh-body);
    color: var(--primary);
    white-space: nowrap;
  }

  a:hover {
    color: var(--primary-hover);
    text-decoration: underline;
  }
`;
